import { render, staticRenderFns } from "./SplitterFormInput.vue?vue&type=template&id=3afd1ea9&scoped=true&"
import script from "./SplitterFormInput.vue?vue&type=script&lang=ts&"
export * from "./SplitterFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./SplitterFormInput.vue?vue&type=style&index=0&id=3afd1ea9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd1ea9",
  null
  
)

export default component.exports